import { render, staticRenderFns } from "./LandingPageDetailsModal.vue?vue&type=template&id=21cb7d9f"
import script from "./LandingPageDetailsModal.vue?vue&type=script&lang=js"
export * from "./LandingPageDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports